export default function editHousingCorporationComment(
  {patch}: any,
  {cid, comment}: {cid: number; comment: string},
): Promise<{}> {
  return patch(`/housing-corporations/comment?corporationId=${cid}`, {comment}, {retryOn401: true})
}



// WEBPACK FOOTER //
// ./src/api/endpoints/housingCorporations/editHousingCorporationComment.tsx